module.exports = __webpack_public_path__ + "static/img/egg.cf1639e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/egg.png
// module id = tmFZ
// module chunks = 1